import React, { forwardRef, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { GridActionsCellItem } from '@mui/x-data-grid';
import * as icons from 'react-bootstrap-icons';
import Inputer from 'Utils/Helpers/Inputer';
import CButton from 'Utils/Helpers/CButton';
import { useSetState } from 'Utils/Helpers/Hooks';
import { useSelector, useDispatch } from 'react-redux';
import { editInfo, users_data } from 'http/components/UserService';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { SetUsersData } from 'Utils/Helpers/HandleApiData';
import { enqueueSnackbar } from 'notistack';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { read } from 'Utils/Helpers/LocalStorage';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function EditUser({ cell, row }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [block, setBlock] = useState(false);
  const { current } = useSelector((state) => ({
    current: state.staff.current,
  }));
  const [controls, setControls] = useSetState ({
    name: {
      id: "name",
      type: 'text',
      placeholder: 'نام و نام خانوادگی',
      value: '',
      icon: <icons.PersonSquare/>,
    },
    mobile: {
      id: "mobile",
      type: 'number',
      placeholder: 'شماره موبایل',
      value: '',
      icon: <icons.Telephone/>,
    }
  });
  const onEnter = () => {
    setControls({name: { value: row.name } });
    setControls({mobile: { value: row.mobile } });
    setBlock(row.block);
  }
  const setControlsValue = (name, value) => {
    setControls({ [name]: { value: value } });
  }
  const setShowDialog = () => {
    setShow(true);
  }
  const handleClose= () => {
    setShow(false);
  }
  const handleChange = (e) => {
    setBlock(e.target.checked);
  }
  const onFinish = async () => {
    const {name, mobile} = controls;
    dispatch(HandleLoading(true));
    if(name.value !== '' && mobile.value !== '') {
      const response = await editInfo(row.id, name.value, mobile.value, block);
      if(response.status) {
        const response2 = await users_data();
        if(response2.status) {
            await dispatch(SetUsersData(response2.data))
            enqueueSnackbar('اطلاعات کاربر با موفقیت ویرایش شد', {variant: 'success'});
            setShow(false);
        } else {
          dispatch(HandleLoading(false));
        }
      } else {
        dispatch(HandleLoading(false));
      }
    } else {
      enqueueSnackbar('اطلاعات به درستی وارد نشده است', {variant: 'error'});
      dispatch(HandleLoading(false));
    }
  }
  return (
    <>
        <GridActionsCellItem
          icon={<icons.Pencil size={16}/>}
          label="Edit"
          onClick={setShowDialog}
          disabled={!current[3][1]}
          hidden={!current[3][1]}
        />
        {
          show &&
          <Dialog
            open={show}
            TransitionComponent={Transition}
            keepMounted
            fullWidth={true}
            maxWidth={'xs'}
            onClose={handleClose}
            TransitionProps={{onEnter: onEnter}}
            aria-describedby="alert-dialog-slide-appointment-edit"
          >
            <DialogTitle className='edit-mode'>
              {`ویرایش مشخصات ${row.name.substring(0, row.name.indexOf(" "))}`}
              <div className='close-btn' onClick={handleClose}>
                  <icons.X/>
              </div>
            </DialogTitle>
            <DialogContent>
              {
                show &&
                <DialogContentText id="alert-dialog-slide-appointment-edit">
                  {
                    Object.keys(controls).map((key, index) => {
                      return (
                        <Inputer
                          key={`inputer_${controls[key].id}`}
                          id={controls[key].id}
                          type={controls[key].type}
                          placeholder={controls[key].placeholder}
                          value={controls[key].value}
                          setValue={setControlsValue.bind(this)}
                          icon={controls[key].icon}
                          className={'mb-2'}
                        />
                      )
                    })
                  }
                  <FormControlLabel 
                    key={`block_user`}
                    control={<Checkbox 
                      checked={block}
                      onChange={handleChange}
                      disabled={row.id === read('local')}
                    />}
                    label={"مسدود کردن کاربر"}
                  />
                </DialogContentText>
              }
            </DialogContent>
            <DialogActions>
              <CButton
                text={'ویرایش کاربر'}
                icon={<icons.Pencil/>}
                onClick={onFinish}
              />
            </DialogActions>
          </Dialog>
        }
      </>
  );
}
